module.exports = __webpack_public_path__ + "static/img/btor-80mid.d6aedf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/btor-80mid.jpg
// module id = /DTI
// module chunks = 0